import React from "react";

import "./go-to-sky.component.scss";

class GoToSky extends React.Component {
  constructor() {
    super();
    let me = this;
    me.button = React.createRef();
    window.addEventListener("scroll", me.scrollHandler.bind(me));
  }
  render() {
    return (
      <button className="go-to-sky" onClick={this.onClick} ref={this.button}>
        Subir
      </button>
    );
  }
  onClick() {
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    document.body.scrollTop = 0; // For Safari
  }
  scrollHandler(){
    let me = this;
    if (
      document.documentElement.scrollTop > 20 ||
      document.body.scrollTop > 20
    ) {
      me.button.current.style.display = "block";
    } else {
      me.button.current.style.display = "none";
    }
  }
}
export default GoToSky;
